'use client';

import commonStyles from '@/app/(website)/commonStyles.module.scss';
import { cx } from 'class-variance-authority';
import styles from './toolsCalculatorsPage.module.scss';
import ToolsCalculatorsSummaryLinks from '@/components/ToolsCalculatorsSummaryLinks';
import { getToolsCalculatorsData } from '@/services/cms';
import { buildImageSrc } from '@/services/formatUtils';
import { notFound } from 'next/navigation';
import ResourceHeader from '@/components/ResourceHeader';
import FadeIn from '@/components/animations/FadeIn';

export default function ToolsCalculatorsPage({
  data
}: {
  data: Awaited<ReturnType<typeof getToolsCalculatorsData>>['data'];
}) {
  const summaryData = data.sectionToolsAndCalculators;

  if (!summaryData) {
    return notFound();
  }

  return (
    <div className={cx(styles.toolsCalculatorsPage)}>
      <ResourceHeader selectedLinkId="tools-calculators" />
      <section className={cx(commonStyles.sectionContent)}>
        <FadeIn>
          <ToolsCalculatorsSummaryLinks
            header="Tools & calculators"
            headingLevel="h1"
            links={[
              {
                image: buildImageSrc(summaryData.featured_tool_image?.url),
                href: summaryData.featured_tool_link || '',
                header: summaryData.featured_tool_heading || '',
                description: summaryData.featured_tool_description || ''
              },
              {
                href: `/calculators/${summaryData.first_featured_calculator?.slug}`,
                header: summaryData.first_featured_calculator?.header || '',
                description:
                  summaryData.first_featured_calculator?.description || ''
              },
              {
                href: `/calculators/${summaryData.second_featured_calculator?.slug}`,
                header: summaryData.second_featured_calculator?.header || '',
                description:
                  summaryData.second_featured_calculator?.description || ''
              },
              {
                href: `/calculators/${summaryData.third_featured_calculator?.slug}`,
                header: summaryData.third_featured_calculator?.header || '',
                description:
                  summaryData.third_featured_calculator?.description || ''
              }
            ]}
          />
        </FadeIn>
      </section>
    </div>
  );
}
